import React, { useEffect, useState } from "react";
import { Col, Form, Row, Button, FormLabel } from "react-bootstrap";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import AddressInput from "../../../components/Common/address";
import CommonInput from "./CommonInput";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useSearchParams } from "react-router-dom";
import { GET_VENDOR_BY_ID } from "../../../services/ApiCalls";

const requiredString = (name) =>
  z
    .string({})
    .trim()
    .min(1, { message: name + " is required" });

const requiredNumber = (name) =>
  z.number({ required_error: name + " is required" });

const optionalString = () => z.string().optional();
const getSchema = (serviceType) => {
  return z.object({
    ...(serviceType !== "Towing" && {
      services: z.object(
        {
          label: requiredString("Service Type"),
          value: requiredString("Service Type"),
        },
        { required_error: "Service Type is required" }
      ),
      // pickUpTypeSize: z.object(
      //   {
      //     label: requiredString("Pick Up Type"),
      //     value: requiredString("Pick Up Type"),
      //   },
      //   { required_error: "Pick Up Type is required" }
      // ),
    }),
    ...(serviceType === "Towing" && {
      licensePlateNumber: requiredString("License Plate Number"),
      make: requiredString("Vehicle Make"),
      model: requiredString("Vehicle Model"),
      color: requiredString("Vehicle Color"),
    }),
    // pickUpAddress: requiredString("Pick Up Address"),
    // pickUpCoordinates: z.object(
    //   {
    //     lng: requiredNumber("pick up Address"),
    //     lat: requiredNumber("pick up Address"),
    //   },
    //   { required_error: "pick up address is required" }
    // ),
    pickUpDate: optionalString("Pick up Date"),
    pickUpTime: optionalString("Pick up Time"),
    // pickUpContactName: requiredString("Pick Up Contact Name"),
    // pickUpContactNumber: requiredString("Pick Up Contact Number"),
    // pickUpCountryCode: requiredString("Pick Up Contact Number"),
    // additionalNotes: optionalString(),
    bookingType: z.enum(["scheduled", "instant"], {
      required_error: "bookingType is required",
    }),
  });
};

const Step1 = ({
  setStep,
  pickUpListing,
  serviceTypes,
  selectedService,
  setStep1FormData,
  step1FormData,

}) => {

  const [searchParams] = useSearchParams();

  const queryString = searchParams.get('q');

  const params = Object.fromEntries(new URLSearchParams(atob(queryString)));


  const [vendorPickUpAddress, setVendorPickUpAddress] = useState(null);
  const [vendorPickUpCoordinates, setVendorPickUpCoordinates] = useState(null);

  const schema = getSchema(selectedService?.value);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    getValues,
    trigger,
    setError: setFormError,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      ...step1FormData,
      bookingType: "scheduled",
      bookingTypeRequest: "normal",
    },
  });

  const onLatLongGet = (latLong) => {
    console.log(latLong, "lola");
    setValue("pickUpCoordinates", latLong, { shouldValidate: true });
  };

  const submitHandler = (values) => {

    values = { ...values, pickUpAddress: vendorPickUpAddress, pickUpCoordinates: vendorPickUpCoordinates, weightCapacity: watch("services")?.weightCapacity, price: params?.price, return_url: params?.return_url, vendorId: params?.vendorId }
    console.log(values);
    setStep1FormData(values);

    console.log(values, "asdfpou");
    setStep(2);
  };


  const handleToggle = () => {
    const newbookingType = watch("bookingType") === "scheduled" ? "instant" : "scheduled";
    setValue("bookingType", newbookingType, { shouldValidate: true });

  };

  console.log(errors, "errors");

  useEffect(() => {
    if (params?.vendorId) {
      fetchVendorDetail(params?.vendorId)
    }
  }, [params.vendorId])

  const fetchVendorDetail = async (vendorId) => {
    const res = await GET_VENDOR_BY_ID(vendorId);
    console.log(res?.data);
    if (res?.data?._id) {
      setVendorPickUpAddress(res?.data?.address);
      setVendorPickUpCoordinates({ lng: res?.data?.providerLocation?.coordinates[0], lat: res?.data?.providerLocation?.coordinates[1] })
    }
  }
  console.log("servicesservicesservices", watch("services"))
  return (
    <>
      <div className="top py-2 d-flex align-items-center gap-10">
        <Button
          onClick={() => setStep(0)}
          className="border-0 p-0"
          variant="transparent"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22 20.418C19.5533 17.4313 17.3807 15.7367 15.482 15.334C13.5833 14.9313 11.7757 14.8705 10.059 15.1515V20.5L2 11.7725L10.059 3.5V8.5835C13.2333 8.6085 15.932 9.74733 18.155 12C20.3777 14.2527 21.6593 17.0587 22 20.418Z"
              fill="black"
              stroke="black"
              stroke-width="2"
              stroke-linejoin="round"
            />
          </svg>
        </Button>
        <h4 className="m-0 fw-sbold">Pickup Location</h4>
      </div>
      <Form onSubmit={handleSubmit(submitHandler)}>
        <Row>
          {/* <Col lg="12" className="my-2">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.6565013517534!2d76.68995827487977!3d30.6999393746002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fef919b7bbba9%3A0xedc14bb423e0f91a!2sSuffescom%20Solutions!5e0!3m2!1sen!2sin!4v1731066681700!5m2!1sen!2sin"
              // width="600"
              height="450"
              className="h-100 w-100 rounded"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </Col> */}
          {/* <Col md="12" className="my-2">
            <label htmlFor="" className="form-label m-0">
              Location
            </label>
            <AddressInput
              name="pickUpAddress"
              placeholder="Business address"
              errorLabel="Address"
              required
              defaultValue=""
              onLatLongGet={onLatLongGet}
              setValue={(val) =>
                setValue("pickUpAddress", val, { shouldValidate: true })
              }
              trigger={() => trigger("pickUpAddress")}
              value={watch("pickUpAddress")}
            />
            {
              <p className="errorColor">
                {(errors?.pickUpAddress && errors?.pickUpAddress?.message) ||
                  (errors?.pickUpCoordinates &&
                    errors?.pickUpCoordinates?.message)}
              </p>
            }
          </Col> */}

          <Col md="12" className="my-2">
            <label htmlFor="" className="form-label m-0">
              Select Service
            </label>
            <Select
              className={"bg-transparent"}
              classNamePrefix="rental"
              options={serviceTypes}
              value={watch("services")}
              onChange={(option) => {
                if (option.weight > 1000 && option.value === 'PickupDrop') {
                  setValue("bookingTypeRequest", "bidding", { shouldValidate: true })
                }
                else {
                  setValue("bookingTypeRequest", "normal", { shouldValidate: true })
                }
                setValue("services", { label: option.labelValue, value: option.labelValue, weightCapacity: option.weight }, { shouldValidate: true })
              }
              }
              styles={{
                container: (baseStyles) => ({
                  ...baseStyles,
                  width: "100%",
                }),
                control: (baseStyles) => ({
                  ...baseStyles,
                  backgroundColor: "transparent",
                  borderRadius: "5px",
                }),
              }}
            />
            {
              <p className="errorColor">
                {(errors?.services && errors?.services?.message) ||
                  (errors?.services?.label &&
                    errors?.services?.label?.message)}
              </p>
            }
          </Col>

          {/* <Col md="12" className="my-2">
            <label htmlFor="" className="form-label m-0">
              Pickup size
            </label>
            <Select
              className={"bg-transparent"}
              classNamePrefix="rental"
              options={pickUpListing}
              value={watch("pickUpTypeSize")}
              onChange={(option) =>
                setValue("pickUpTypeSize", option, { shouldValidate: true })
              }
              styles={{
                container: (baseStyles) => ({
                  ...baseStyles,
                  width: "100%",
                }),
                control: (baseStyles) => ({
                  ...baseStyles,
                  backgroundColor: "transparent",
                  borderRadius: "5px",
                }),
              }}
            />
            {
              <p className="errorColor">
                {(errors?.pickUpTypeSize &&
                  errors?.pickUpTypeSize?.message) ||
                  (errors?.pickUpTypeSize?.label &&
                    errors?.pickUpTypeSize?.label?.message)}
              </p>
            }
          </Col> */}



          {/* Toggle bookingType */}
          <Col md="12" className="my-2">
            <label className="form-label m-0">Booking Type Need</label>
            <div className="d-flex align-items-center gap-2">
              <span>Scheduled</span>
              <Form.Check
                type="switch"
                id="bookingType-toggle"
                onChange={handleToggle}
                checked={watch("bookingType") === "instant"}
              />
              <span>Instant</span>
            </div>
            {errors?.bookingType && (
              <p className="errorColor">{errors.bookingType.message}</p>
            )}
          </Col>

          {watch("bookingType") === "scheduled" && (
            <>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label m-0">
                  Pickup Date
                </label>
                <CommonInput
                  register={register}
                  errors={errors}
                  name="pickUpDate"
                  type="date"
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label m-0">
                  Pickup Time
                </label>
                <CommonInput
                  register={register}
                  errors={errors}
                  name="pickUpTime"
                  type="time"
                />
              </Col>
            </>
          )}



          {/* <Col md="12" className="my-2">
            <label htmlFor="" className="form-label m-0">
              Pickup Contact Name
            </label>
            <CommonInput
              register={register}
              errors={errors}
              name={"pickUpContactName"}
            />
          </Col>
          <Col md="12" className="my-2">
            <label htmlFor="" className="form-label m-0">
              Pickup Contact Number
            </label>
            <PhoneInput
              value={watch("pickUpContactNumber")}
              onChange={(data, { dialCode }) => {
                setValue("pickUpContactNumber", data, { shouldValidate: true });
                setValue("pickUpCountryCode", dialCode);
              }}
              country={"us"}
            />

            {
              <p className="errorColor">
                {errors?.pickUpContactNumber &&
                  errors?.pickUpContactNumber?.message}
              </p>
            }
          </Col>
          <Col md="12" className="my-2">
            <label htmlFor="" className="form-label m-0">
              Additional Notes
            </label>
            <textarea
              name=""
              rows={4}
              id=""
              {...register("additionalNotes")}
              className="form-control bg-light h-auto"
            ></textarea>
            {
              <p className="errorColor">
                {errors?.additionalNotes && errors?.additionalNotes?.message}
              </p>
            }
          </Col> */}

          {selectedService?.value === "Towing" && (
            <>
              <Col md="12" className="my-2">
                <FormLabel className="form-label text-uppercase fw-sbold m-0">
                  Vehicle details
                </FormLabel>
              </Col>
              <Col md="12" className="my-2">
                <label htmlFor="" className="form-label m-0">
                  License Plate Number
                </label>
                <CommonInput
                  register={register}
                  errors={errors}
                  name={"licensePlateNumber"}
                />
              </Col>
              <Col md="12" className="my-2">
                <label htmlFor="" className="form-label m-0">
                  Make
                </label>
                <CommonInput
                  register={register}
                  errors={errors}
                  name={"make"}
                />
              </Col>

              <Col md="12" className="my-2">
                <label htmlFor="" className="form-label m-0">
                  Model
                </label>
                <CommonInput
                  register={register}
                  errors={errors}
                  name={"model"}
                />
              </Col>
              <Col md="12" className="my-2">
                <label htmlFor="" className="form-label m-0">
                  Color
                </label>
                <CommonInput
                  register={register}
                  errors={errors}
                  name={"color"}
                />
              </Col>
            </>
          )}

          <Col lg="12" className="my-2">
            <Button
              type="submit"
              className="btn d-flex align-items-center justify-content-center commonBtn w-100"
            >
              Next
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default Step1;
